import React, {DetailedHTMLProps, FC, HTMLAttributes} from 'react';

import classNames from 'classnames';

import {Price} from 'components/price/price';

import s from './priceBlock.scss';

type PropsType = {
    price: number;
    finalPrice: number;
    priceClassName?: string;
} & DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>;

/**
 * Renders a price block component with discounted price crossed out
 */
export const PriceBlock: FC<PropsType> = ({
    className,
    finalPrice,
    price,
    priceClassName,
    ...props
}) => {
    const hasDiscount = finalPrice !== null && finalPrice < price;

    return (
        <div {...props} className={classNames(s.priceBlock, className)}>
            {hasDiscount && (
                <span
                    aria-label="Regular price"
                    className={classNames(s.price, s.regular, priceClassName)}
                >
                    <Price>{price}</Price>
                </span>
            )}
            <span
                className={classNames(
                    s.price,
                    {
                        [s.discounted]: hasDiscount,
                    },
                    priceClassName,
                )}
                aria-label={`${hasDiscount ? 'Discounted' : 'Regular'} price`}
            >
                <Price>{finalPrice}</Price>
            </span>
        </div>
    );
};
